// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"3b023583","262":"59426fb7","385":"02445215","573":"3c7893fd","623":"f794c74a","637":"bfae8131","669":"26a8303e","952":"d7c77c7c"}[chunkId] + ".chunk.js";
};